/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiscordRelayMessageUpdateMessage,
    DiscordRelayMessageUpdateMessageFromJSON,
    DiscordRelayMessageUpdateMessageFromJSONTyped,
    DiscordRelayMessageUpdateMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 
     * @type {DiscordRelayMessageUpdateMessage}
     * @memberof InlineObject10
     */
    message: DiscordRelayMessageUpdateMessage;
    /**
     * Bot authentication token
     * @type {string}
     * @memberof InlineObject10
     */
    botToken: string;
}

export function InlineObject10FromJSON(json: any): InlineObject10 {
    return InlineObject10FromJSONTyped(json, false);
}

export function InlineObject10FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject10 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': DiscordRelayMessageUpdateMessageFromJSON(json['message']),
        'botToken': json['botToken'],
    };
}

export function InlineObject10ToJSON(value?: InlineObject10 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': DiscordRelayMessageUpdateMessageToJSON(value.message),
        'botToken': value.botToken,
    };
}


